import './Demo.page.less';
import {
    IMAGE_PASSWORD_ICON,
    IMAGE_LOGO_FULL,
    IMAGE_SAD_HOUSE
} from 'pluton-core/lib/constants/image.constant';
import Image from '../../../controls/image/Image.jsx';
import AuthInput from '../../../controls/authInput/AuthInput.jsx';
import StatusSelector from '../../../controls/statusSelector/StatusSelector.jsx';


class DemoPage extends React.Component {

    static propTypes = {
    };

    render() {
        const { date } = this.props;

        return (
            <div className="app-container">

                <div className="flex-container flex-container--column">
                    <h3>
                        Main logo component.<br/>
                        -----------------------
                    </h3>

                    <div className="flex__item-1 flex__item--center">
                        <Image
                            width='100'
                            height='auto'
                            className='logo_full'
                            src={IMAGE_LOGO_FULL}
                        />
                    </div>

                    <h3>
                        Auth input component. <br/>
                        ------------------------
                    </h3>
                    <div className="flex__item-1 flex__item--center">
                        <AuthInput
                            placeholder="placeholder"
                            iconUrl={ IMAGE_PASSWORD_ICON }
                        />
                    </div>

                    <h3>
                        Drop down for selecting status <br/>
                        ------------------------
                    </h3>
                    <div className="flex__item-1 flex__item--center">
                        <StatusSelector
                            userName="Artur"
                        />
                    </div>

                    <h3>
                        Connecting Alert <br/>
                        ------------------------
                    </h3>
                    <h3>
                        Waiting bar <br/>
                        ------------------------
                    </h3>
                    <div className="flex__item-1 flex__item--center">
                    </div>

                    <h3>
                        Home menu <br/>
                        ------------------------
                    </h3>

                    />

                    <h3>
                        Household component <br/>
                        ------------------------
                    </h3>

                </div>

            </div>
        );
    }
}

export default DemoPage;



// WEBPACK FOOTER //
// ./app/components/pages/tmp/demo/Demo.page.jsx